var map = {
	"./pattern-1.css": [
		673,
		673
	],
	"./pattern-2.css": [
		914,
		914
	],
	"./pattern-3.css": [
		271,
		271
	],
	"./pattern-4.css": [
		560,
		560
	],
	"./pattern-5.css": [
		941,
		941
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 976;
module.exports = webpackAsyncContext;